import { MantineThemeOverride } from '@mantine/core';

export type CollapseTheme = NonNullable<MantineThemeOverride['components']>['Collapse'];

export const Collapse: CollapseTheme = {
  // todo: define
};
